import React from "react";
import moment from "moment";
import locale from "../../locale";

function EpisodeMember(props)
{
	const name = locale.getProperty(props, 'fullname');
	const description = locale.getProperty(props, 'description');

	const htmlDescription = description.replace(/(^|\s)(https?:\/\/[^\s]+)(\s|$)/, '$1<a href="$2" target="_blank">$2</a>$3');

	return (
		<p className="episode-member">
			<span className="episode-member-name">{name}</span><br/>
			<span className="episode-member-info" dangerouslySetInnerHTML={{__html: htmlDescription}} />
		</p>
	);
}

function Episode(props)
{
	const settings = props.settings;
	const timeStart = moment.unix(props.timeStart);
	const timeStop = moment.unix(props.timeStop);
	const name = locale.getProperty(props, 'name');
	const info = locale.getProperty(props, 'info');
	const section = locale.getProperty(props, 'section');
	const sectionColor = props.color;

	const members = []
		.concat(...props.speakers || [])
		.concat(...props.moderators || [])
	;

	const showMembers = !settings.hasOwnProperty('showMembers') || settings.showMembers;

	return (
		<article>
			<h3 className="episode-time" style={props.settings.styleTime}>
				{timeStart.format('HH:mm')} - {timeStop.format('HH:mm')}
			</h3>
			<div className="episode-info">
				<h3 className="episode-name" style={props.settings.styleName}>
					{name}
				</h3>

				{section ? <h3 className="episode-section" style={{color: `#${sectionColor}`}}>
					{section}
				</h3> : null}

				{showMembers ? members.map((member, index) =>
					<EpisodeMember {...member} key={`${index}`} />
				) : null}

				<p className="episode-description" dangerouslySetInnerHTML={{__html: info.replace(/\\n/g, '<br />')}} />

				{props.link ?
					<div className={`block-footer`}>
						<a href={props.link.href} target="_blank" className={`btn-link btn-link-arrow`}>
							{locale.getProperty(props.link, 'title')}
						</a>
					</div>
					: null
				}
			</div>
		</article>
	);
}

function SubTitle({text, style})
{
	if (!text) {
		return null;
	}

	if (text instanceof Array) {
		text = text.map((text, index) => <p key={`line_${index}`}>{text}</p>)
	}

	return <div className="episodes-subtitle" style={style}>{text}</div>;
}

function EpisodeDaysList({episodesByDate, settings})
{
	return (
		<div className="episodes-days-list">
			{Object.keys(episodesByDate).map((dateKey) =>
				<div key={`episode_date_${dateKey}`}>
					<h2 style={settings.styleDate}>{episodesByDate[dateKey].date.format('D MMMM')}</h2>

					{episodesByDate[dateKey].episode.map((episode, index) => (
						<Episode key={'episode_' + (episode.id || index)} {...episode} settings={settings}/>
					))}
				</div>
			)}
		</div>
	);
}

class EpisodeDaysTabs extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			activeTab: 0,
		};
	}

	componentDidMount()
	{
		this.setState({activeTab: 0});
	}

	render()
	{
		const {episodesByDate, settings} = this.props;
		const {activeTab} = this.state;

		return (
			<div className="episodes-days-tabs">
				{Object.keys(episodesByDate).map((dateKey, index) =>
					<h2
						key={`episode_date_${dateKey}_tab_title`}
						style={settings.styleDate}
						className={`episodes-days-tab-title` + (index === activeTab ? ' active-tab' : '')}
						onClick={() => this.setState({activeTab: index})}
					>
						{episodesByDate[dateKey].date.format('D MMMM')}
					</h2>
				)}
				{Object.keys(episodesByDate).map((dateKey, index) =>
					<div
						key={`episode_date_${dateKey}_tab_content`}
						className={`episodes-days-tab-content` + (index === activeTab ? ' active-tab' : '')}
					>
						{episodesByDate[dateKey].episode.map((episode) => <Episode {...episode} settings={settings}/>)}
					</div>
				)}
			</div>
		);
	}
}

function EpisodesByDaysView({episodes, settings})
{
	const episodesByDate = {};
	episodes
		.sort((a, b) => a.timeStart - b.timeStart)
		.forEach((episode) => {
			const date = moment.unix(episode.timeStart);
			const dateKey = date.format('D MMM');

			if (!episodesByDate[dateKey]) {
				episodesByDate[dateKey] = {
					date,
					episode: [],
				};
			}

			episodesByDate[dateKey].episode.push(episode);
		})
	;

	const episodeDaysViews = {
		'list': EpisodeDaysList,
		'tabs': EpisodeDaysTabs,
	};
	const EpisodeDaysView = episodeDaysViews[settings.dateListView] || episodeDaysViews['list'];

	return <EpisodeDaysView episodesByDate={episodesByDate} settings={settings} />
}

class EpisodeStreamsView extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			streamIndex: 0
		};
	}

	componentDidMount() {
		this.setState({streamIndex: 0});
	}

	render() {
		const {streams, settings} = this.props;
		const {streamIndex} = this.state;

		if (!(streams instanceof Array)) {
			return null;
		}

		if (streams.length === 1) {
			return <EpisodesByDaysView episodes={streams[streamIndex].episode} settings={settings}/>;
		}

		return (
			<div>
				<div className="episode-streams-tabs">
					{streams.map((stream, index) => (
						<h2 className={`episodes-stream-tab-title ` + (streamIndex === index ? 'active-tab' : '')}
							key={index}
							onClick={() => this.setState({streamIndex: index})}
						>
							{locale.getProperty(stream, 'description')}
						</h2>
					))}
				</div>
				<EpisodesByDaysView episodes={streams[streamIndex].episode} settings={settings}/>
			</div>
		);
	}
}

class LayoutEpisodes extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			streams: null,
		};
	}

	componentDidMount() {
		const {settings} = this.props;
		let episodes;
		let streams;

		if (settings.source instanceof Array) {
			episodes = settings.source.map(episode => {
				episode.timeStart = moment(episode.timeStart).unix();
				episode.timeStop = moment(episode.timeStop).unix();

				return episode;
			});
			streams = [{
				episode: episodes,
			}];
		} else {
			const {event} = this.props;

			episodes = [];
			event.stream.forEach((stream) => {
				stream.episode.forEach((episode) => {
					episodes.push(episode);
				});
			});

			streams = event.stream;
		}

		if (!settings.hasOwnProperty('splitStream') || !settings.splitStream) {
			episodes = streams.reduce((result, stream) => result.concat(stream.episode), []);
			streams = [{
				episode: episodes,
			}]
		}

		streams = streams.filter(stream => stream.episode.length > 0);

		this.setState({streams});
	}

	render()
	{
		const {streams} = this.state;
		const {settings} = this.props;

		if (!settings) {
			return null;
		}

		if (!streams || !streams.length) {
			return null;
		}

		return (
			<aside className="section-episodes" id={settings.name} style={settings.style}>
				<h1 style={settings.styleHeader}>{locale.getProperty(settings, 'title') || locale.get('layer-episodes-title')}</h1>

				<div className="landing-nav-section-text">
					<SubTitle {...settings.subtitle} />

					<EpisodeStreamsView streams={streams} settings={settings} />
				</div>
			</aside>
		);
	}
}

export default LayoutEpisodes;
